module.exports = __webpack_public_path__ + "static/media/favorite-icon-pet.310690cb.svg";